import React from "react";
import ContentWrapper from "../../mt/ContentWrapper";
import DrawingTable from "./DrawingTable";
import ResultTable from "./ResultTable";


const ResultKPDay = (props) => {

    return <ContentWrapper>
        <DrawingTable {...props} />
        <ResultTable {...props} />
    </ContentWrapper>
}

export default ResultKPDay;